/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import toast from '../../../services/toast';
export default {
  name: 'user-activity-details',
  components: {},
  props: [],
  data () {
    return {
      nextStep:'',
      loadmoreData: {},
      userLoading: false,
      DeleteId:'',
      checkDataTaskModal:false,
      userTaskList:{},
      userTaskListResults:[]
    }
  },
  computed: {
  ...mapGetters([
    'getUserTaskGetters'
  ]),
  getUserTaskListedFun(){
    return this.userTaskList = this.$store.getters.getUserTaskGetters.data
  },
  SetIntialStatus() {
    if (this.userTaskList != undefined) {
      this.nextStep = this.userTaskList.next
      this.userTaskListResults = this.userTaskList.results
    }
  }
  },
  mounted () {
    this.getOrgDetailsByIdDetailsFun
    this.getUserTaskListedFun
    this.SetIntialStatus
  },
  methods: {
    getRemoveListAgain() {
      this.$store.dispatch('getUserTaskListFun', {id:this.$route.params.UserID}).then((res) => {
        this.userTaskList = this.$store.getters.getUserTaskGetters.data
      }).catch((err) => {
      })
    },
    showRemovedTaskModalFun(id){
    $("body").addClass("task_modal_actv");
    this.checkDataTaskModal = true
    this.DeleteId = id
  },
  removeModalItemConfirmFun(){
    this.$store.dispatch('removeTaskDetailsFun', {
      id: this.DeleteId,
    })
    .then((res) => {
      if (res.status == '200') {      
        toast.success(res.data.msg); 
        $("body").removeClass("task_modal_actv");
        this.getRemoveListAgain()
        this.checkDataTaskModal = false
        this.DeleteId = ''
      }
    }).catch((err) => {
      toast.error(err.data.user_msg);  
    })
  return;
  },
  closeRemoveItemModalFun(){
    $("body").removeClass("task_modal_actv");
    this.checkDataTaskModal = false
    this.DeleteId = ''
  }
  },
  watch:{
    getUserTaskListedFun(){
      return this.userTaskList = this.$store.getters.getUserTaskGetters.data
    },
    SetIntialStatus() {
      if (this.userTaskList != undefined) {
        this.nextStep = this.userTaskList.next
        this.userTaskListResults = this.userTaskList.results
      }
    }
  }
}